import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import('@/views/Login/Login.vue')
const DashView = () => import('@/views/DashView/DashView.vue')
const Dashboard = () => import('@/views/DashView/Dashboard/Dashboard.vue')
const UserList = () => import('@/views/DashView/User/UserList.vue')
const UserAdd = () => import('@/views/DashView/User/UserAdd.vue')
const CustomerList = () => import('@/views/DashView/Customer/CustomerBasic.vue')
const StoreList = () => import('@/views/DashView/Stores/StoreList.vue')
const TransactionsList = () =>
  import('@/views/DashView/Transactions/TransactionsList.vue')
const GlobalList = () => import('@/views/DashView/Global/GlobalList.vue')
const OutletPriceList = () =>
  import('@/views/DashView/OutletPrice/OutletPriceList.vue')
const MenuGroupList = () =>
  import('@/views/DashView/MenuGroup/MenuGroupList.vue')
const MenuItemList = () => import('@/views/DashView/MenuItem/MenuItemList.vue')
const MenuPriceList = () =>
  import('@/views/DashView/MenuPrice/MenuPriceList.vue')
const MenuItemLimitList = () =>
  import('@/views/DashView/MenuItemLimit/MenuItemLimitList.vue')
const MenuGroupLimitList = () =>
  import('@/views/DashView/MenuGroupLimit/MenuGroupLimitList.vue')
const ModifierItemList = () =>
  import('@/views/DashView/ModifierItem/ModifierItemList.vue')
const ModifierPriceList = () =>
  import('@/views/DashView/ModifierPrice/ModifierPriceList.vue')
const StoreDeliveryScheduleList = () =>
  import('@/views/DashView/StoreDeliverySchedule/StoreDeliveryScheduleList.vue')
const MenuGroupScheduleList = () =>
  import('@/views/DashView/MenuGroupScheduleList/MenuGroupScheduleList.vue')
const PosOrder = () => import('@/views/DashView/PosOrder/PosOrder.vue')
const PosOrderQR = () => import('@/views/DashView/PosOrder/QRPage.vue')
const PosOrderResult = () => import('@/views/DashView/PosOrder/PosResult.vue')
const SaleMenuScheduleList = () =>
  import('@/views/DashView/SaleMenuSchedule/SaleMenuScheduleList.vue')
const StoreOpenScheduleList = () =>
  import('@/views/DashView/StoreOpenSchedule/StoreOpenScheduleList.vue')
const StoreGeofence = () =>
  import('@/views/DashView/StoreGeofence/StoreGeofence.vue')
const OrderList = () =>
  import('@/views/DashView/OrderReport/OrderReportList.vue')
const OrderReportDetail = () =>
  import('@/views/DashView/OrderReport/OrderReportDetail.vue')
const MenuImageBatchUpload = () =>
  import('@/views/DashView/MenuImageBatchUpload/MenuImageBatchUpload.vue')
const MenuBatchUpload = () =>
  import('@/views/DashView/MenuBatchUpload/MenuBatchUpload.vue')
const CustomerBatchUpload = () =>
  import('@/views/DashView/CustomerBatchUpload/CustomerBatchUpload.vue')
const DonwloadOrders = () =>
  import('@/views/DashView/DownloadOrders/DownloadOrders.vue')
const FeeCalculationSetting = () =>
  import('@/views/DashView/FeeCalculationSetting/FeeCalculationSetting.vue')
const DeliverySetting = () =>
  import('@/views/DashView/DeliverySetting/DeliverySetting.vue')
const SelectTable = () => import('@/views/DashView/OrderReport/SelectTable.vue')
const VariantCategory = () =>
  import('@/views/DashView/VariantCategory/VariantCategory.vue')
const VariantsList = () =>
  import('@/views/DashView/VariantsList/VariantsList.vue')
const SalesSummary = () =>
  import('@/views/DashView/SalesSummary/SalesSummary.vue')
const ChangeOrderStatus = () =>
  import('@/views/DashView/ChangeOrderStatus/ChangeOrderStatus.vue')
const MerchantConfig = () =>
  import('@/views/DashView/MerchantConfig/MerchantConfig.vue')
const MerchantStaff = () =>
  import('@/views/DashView/MerchantStaff/MerchantStaff.vue')
const SelectBuilding = () =>
  import('@/views/DashView/OrderReport/SelectBuilding.vue')
const WaitingList = () => import('@/views/DashView/WaitingList/WaitingList.vue')
const UpdateVersion = () =>
  import('@/views/DashView/UpdateVersion/UpdateVersion.vue')
const ReviewSettings = () => import('@/views/DashView/ReviewSettings/List.vue')
const Reviews = () => import('@/views/DashView/Reviews/List.vue')
const EDCLayout = () => import('@/views/EDC/Layout.vue')
const EDCHomepage = () => import('@/views/EDC/Homepage/index.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { withoutAuth: true }
    },
    {
      path: '/',
      component: DashView,
      children: [
        {
          path: '/',
          component: Dashboard,
          name: 'Dashboard'
        },
        {
          path: '/user',
          component: UserList,
          name: 'User Settings'
        },
        {
          path: '/user/add',
          component: UserAdd,
          name: 'UserAdd'
        },
        {
          path: '/user/:id/edit',
          component: UserAdd,
          name: 'UserEdit'
        },
        {
          path: '/stores',
          component: StoreList,
          name: 'Outlet List'
        },
        {
          path: '/transactions-data',
          component: TransactionsList,
          name: 'Transactions Data'
        },
        {
          path: '/outlet-price',
          component: OutletPriceList,
          name: 'Outlet Prices'
        },
        {
          path: '/global',
          component: GlobalList,
          name: 'Global'
        },
        {
          path: '/menu-group',
          component: MenuGroupList,
          name: 'Menu Group'
        },
        {
          path: '/menu-item',
          component: MenuItemList,
          name: 'Menu Item'
        },
        {
          path: '/variants-list/:outletcode/:menuitemcode',
          component: VariantsList,
          name: 'Variants List'
        },
        {
          path: '/variant-category',
          component: VariantCategory,
          name: 'Menu Variant Category'
        },
        {
          path: '/menu-price',
          component: MenuPriceList,
          name: 'Menu Price'
        },
        {
          path: '/menu-group-limit',
          component: MenuGroupLimitList,
          name: 'Menu Group Limit'
        },
        {
          path: '/menu-item-limit',
          component: MenuItemLimitList,
          name: 'Menu Item Limit'
        },
        {
          path: '/modifier-item',
          component: ModifierItemList,
          name: 'Modifier Item'
        },
        {
          path: '/modifier-price',
          component: ModifierPriceList,
          name: 'Modifier Price'
        },
        {
          path: '/store-delivery-schedule',
          component: StoreDeliveryScheduleList,
          name: 'Outlet Delivery Schedule'
        },
        {
          path: '/pos-order',
          component: PosOrder,
          name: 'Pos Order'
        },
        {
          path: '/pos-qr',
          component: PosOrderQR,
          name: 'Pos Order QR'
        },
        {
          path: '/pos-result',
          component: PosOrderResult,
          name: 'Pos Order Result'
        },
        {
          path: '/menu-group-schedule',
          component: MenuGroupScheduleList,
          name: 'Menu Group Schedule'
        },
        {
          path: '/sale-menu-schedule',
          component: SaleMenuScheduleList,
          name: 'Sale Menu Schedule'
        },
        {
          path: '/store-open-schedule',
          component: StoreOpenScheduleList,
          name: 'Outlet Open Schedule'
        },
        {
          path: '/store-geofence',
          component: StoreGeofence,
          name: 'Outlet Geofence'
        },
        {
          path: '/order-report',
          component: OrderList,
          name: 'Order List'
        },
        {
          path: '/order-report/:type/:id',
          component: OrderReportDetail,
          name: 'Order List / Order List Detail'
        },
        {
          path: '/menu-image-batch-upload',
          component: MenuImageBatchUpload,
          name: 'Menu Image Batch Upload'
        },
        {
          path: '/menu-batch-upload',
          component: MenuBatchUpload,
          name: 'Menu Batch Upload'
        },
        {
          path: '/customer-batch-upload',
          component: CustomerBatchUpload,
          name: 'Customer Batch Upload'
        },
        {
          path: '/download-orders',
          component: DonwloadOrders,
          name: 'Download Orders'
        },
        {
          path: '/customer-list',
          component: CustomerList,
          name: 'Customer List'
        },
        {
          path: '/fee-calculation-setting',
          component: FeeCalculationSetting,
          name: 'Fee Calculation Setting'
        },
        {
          path: '/delivery-setting',
          component: DeliverySetting,
          name: 'Delivery Setting'
        },
        {
          path: '/merchant-config',
          component: MerchantConfig,
          name: 'Merchant Config'
        },
        {
          path: '/merchant-staff',
          component: MerchantStaff,
          name: 'Merchant Staff'
        },
        {
          path: '/select-table',
          component: SelectTable,
          name: 'select table'
        },
        {
          path: '/select-building',
          component: SelectBuilding,
          name: 'select building'
        },
        {
          path: '/sales-summary',
          component: SalesSummary,
          name: 'Sales Summary'
        },
        {
          path: '/change-order-status',
          component: ChangeOrderStatus,
          name: 'Change Order Status'
        },
        {
          path: '/waiting-list',
          component: WaitingList,
          name: 'Waiting List'
        },
        {
          path: '/update-version',
          component: UpdateVersion,
          name: 'Update Version'
        },
        {
          path: '/review-settings',
          component: ReviewSettings,
          name: 'Review Settings'
        },
        {
          path: '/reviews',
          component: Reviews,
          name: 'Reviews'
        }
      ]
    },
    {
      path: '/edc',
      component: EDCLayout,
      children: [
        {
          path: '/edc',
          component: EDCHomepage,
          name: 'Home Screen'
        },
      ]
    }
  ]
})
